import React, { useCallback, useMemo } from 'react';
import usePagination from './usePagination';
import { CardPagination } from '../components/Card';

const useCardPagination = (data, pageSize, paginationClassName = '') => {
  const [currentPageNumber, setCurrentPageNumber, maxPage, shownItems] =
    usePagination(data, pageSize);

  const handlePrevClick = useCallback(
    () => setCurrentPageNumber((prev) => (prev -= 1)),
    [setCurrentPageNumber]
  );
  const handleNextClick = useCallback(
    () => setCurrentPageNumber((prev) => (prev += 1)),
    [setCurrentPageNumber]
  );

  const pagination = useMemo(
    () => (
      <CardPagination
        className={paginationClassName}
        onPrevClick={currentPageNumber !== 0 ? handlePrevClick : undefined}
        onNextClick={
          currentPageNumber !== maxPage - 1 ? handleNextClick : undefined
        }
        currentPage={currentPageNumber + 1}
        maxPage={maxPage}
      />
    ),
    [handlePrevClick, handleNextClick, currentPageNumber, maxPage]
  );

  return {
    shownItems,
    pagination,
  };
};

export default useCardPagination;
